module.exports = __webpack_public_path__ + "media/images/msec_4-4-6b52a42663ced09aa4d1bf2b05760d7e.png";